/**
 * Client-side credit display helpers.
 * Billing is stored in PCU where 1 PCU = $0.01 USD.
 */

const PCU_TO_USD_RATE = 0.01

/**
 * Converts PCU into a USD number for display purposes.
 */
export function pcuToUsd(pcuAmount: string | number | null | undefined): number {
  const numericPcu =
    typeof pcuAmount === "string"
      ? parseFloat(pcuAmount)
      : Number(pcuAmount ?? 0)

  if (!Number.isFinite(numericPcu)) {
    return 0
  }

  return numericPcu * PCU_TO_USD_RATE
}

/**
 * Formats a USD amount with fixed precision.
 * Useful for per-chat usage where small values matter.
 */
export function formatUsdFromPcu(
  pcuAmount: string | number | null | undefined,
  options?: {
    minimumFractionDigits?: number
    maximumFractionDigits?: number
  }
): string {
  const usdAmount = pcuToUsd(pcuAmount)

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: options?.minimumFractionDigits ?? 2,
    maximumFractionDigits: options?.maximumFractionDigits ?? 4,
  }).format(usdAmount)
}

/**
 * Formats a USD amount compactly for sidebar/header balance displays.
 */
export function formatCompactUsdFromPcu(
  pcuAmount: string | number | null | undefined
): string {
  const usdAmount = pcuToUsd(pcuAmount)

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(usdAmount)
}
